/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import XDownloader from "./Classes/XDownloader";
import Gri from './Classes/Gri';
import Accordion from "./Classes/Accordion";
import HighlightsSlider from './Classes/HighlightsSlider';
import Video from './Classes/Video';
import CountUpNumbers from './Classes/CountUpNumbers';
import Header from './Classes/Header';
import ToTop from './Classes/ToTop';
import InteractiveSVGPopup from './Classes/InteractiveSVGPopup';
import InteractiveSVGTriggerTarget from './Classes/InteractiveSVGTriggerTarget'
import xdownloaderConfig from './xdownloader-config';
import Tracking from './Classes/Tracking';
import InterActiveButtonSVG from './Classes/InteractiveButtonSVG';
import InteractiveSVGLink from "./Classes/InteractiveSVGLink";


var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;
var downloaderInstance = null;

var accordionInstance = null;
var cvInstance = null;
var sdgInstance = null;
var highlightsSliderInstane = null;
var videoInstance = null;
var countUpNumbersInstance = null;
var headerInstance = null;
var toTopInstance = null;
var trackingInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }
};

// Initialize on document ready
document.addEventListener("DOMContentLoaded", function () {

  trackingInstance = new Tracking();

  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  new Gri();

  responsiveTableInstance = new ResponsiveTablesLight({
    tableComponentSelector: '.ns-table-wrap',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.ns-table-wrap table'
  });

  downloaderInstance = new XDownloader(xdownloaderConfig);

  cvInstance = new Accordion({accordions: '.ns-cv__header'});
  sdgInstance = new Accordion({accordions: '.ns-sdg-accordion__header'});

  accordionInstance = new Accordion({
    accordions: '.ns-accordion__head'
  });

  highlightsSliderInstane = new HighlightsSlider();

  countUpNumbersInstance = new CountUpNumbers({
    numbersSelector: '.countup .ns-keyfigure__figure',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['de-DE', 'en-US'],
    decimalArray: ['.', '.'],
    thousandSepArray: ['’', '’'],
  });
  videoInstance = new Video();

  headerInstance = new Header();

  toTopInstance = new ToTop();

  new InteractiveSVGPopup('.svg-value-creation-model', '');
  new InteractiveSVGPopup('.svg-compensation-chart', 'fixed_compensation');

  new InterActiveButtonSVG();
  new InteractiveSVGTriggerTarget();
  new InteractiveSVGLink();
});
